import React from "react";
import { Link } from "react-router-dom";
import "../HomePage/Home.scss";
import garethPic from "../images/gareth.jpg";

const About = () => {
    return (
        <section className="about-page">
            <h2 className="main-header">Reliable support with a smile</h2>
            <div className="top-line"></div>
            <div className="home-container">
                <figure className="image-wrap">
                    <img src={garethPic} alt="Gareth Allen" />
                    <figcaption className="image-caption">Gareth Allen BSc Hons</figcaption>
                </figure>
                <div className="about-wrap">
                    <p>
                        Hi, my name is Gareth Allen, I am a currently practicing, NMC
                        registered and DBS checked Mental Health Nurse. I've started a
                        service in Bradford-on-Avon and surrounding areas offering
                        befriending, companionship and day time respite for loved ones and
                        carers. I aim to enable people to do the things they enjoy with a view to improving their overall
                        wellbeing.
                    </p>
                    <p>
                        I've been a registered mental nurse since 2017 and have worked for
                        the NHS on a dementia ward in Cornwall. More recently I have worked
                        with community and specialist teams in Wiltshire and an older
                        persons team in South Gloucestershire.
                    </p>
                    <p>
                        I have enjoyed much of my nursing career so far but have lately
                        seen such a great need for the best quality care in peoples own
                        homes that I have made the leap and started my own small independent
                        business.
                    </p>
                    <p>
                        I will provide the best quality service to you or your loved one
                        and always with a smile. I am fully insured and have an up to date Police DBS check.
                    </p>
                    <Link to="/contact" className="contact-button">
                        Contact me
                    </Link>
                    <a
                        href="/Gareth%20BOA%20leaflet%202026.pdf"
                        className="contact-button"
                        download
                    >
                        Download my leaflet
                    </a>
                </div>
            </div>
        </section>
    );
};

export default About;
